"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EscapePressHandler = void 0;
var _useKeyboardAction = require("../hooks/useKeyboardAction");
var _keyboard = require("../browser/keyboard");
// `useKeyboardAction` needs to be part of a component so it can use the hook
const EscapePressHandler = _ref => {
  let {
    onEscapePress
  } = _ref;
  (0, _useKeyboardAction.useKeyboardAction)({
    keyDownBindings: [{
      keyName: _keyboard.KeyboardKey.Escape,
      onKeyDown: onEscapePress
    }]
  });
  return null;
};
exports.EscapePressHandler = EscapePressHandler;
//# sourceMappingURL=EscapePressHandler.js.map